import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "font-size-16-600" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "line-height-15 mt-2" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "font-grey-dark" }
const _hoisted_6 = { class: "line-height-15 mt-2" }
const _hoisted_7 = {
  key: 0,
  class: "text-center pr-2"
}

import {computed, reactive, ref, onMounted, nextTick, watch} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {productService} from '@/api/services/product';
import {useSettingsStore} from '@/api/store/settings';
import {useCartStore} from '@/api/store/cart';
import QuantityEditor from '@/components/QuantityEditor.vue';
import ButtonBase from "@/components/custom/ButtonBase.vue";
import {useUserStore} from "@/api/store/user";
import {firstLetterUppercase} from "@/components/Helpers/Utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductView',
  setup(__props) {

const userStore = useUserStore();
const settingsStore = useSettingsStore();
const cartStore = useCartStore();

const route = useRoute();
const router = useRouter();

const state = reactive({
  item: null as any,
  qty: 1 as number,
  fav: false as boolean,
});

const showMore = ref(false);
const isTextOverflowing = ref(false);
const descriptionContainer = ref<HTMLElement | null>(null);

const toggleText = () => {
  showMore.value = !showMore.value;
};


productService.getProduct(+route.params.id).then((response) => {
  state.item = response.data;
  router.currentRoute.value.meta.title = state.item.name;
}).catch((err) => {
  //router.push({ name: 'shop' });
});

const addProduct = () => {
  
  cartStore.addItem(null, state.item.id, state.qty).then((res) => {
    console.log(res);
    router.push({name: 'shopping-cart'});
  }).catch((error) => {
    settingsStore.error = true;
    settingsStore.error_message = "This item may be out of stock or no longer available from the supplier."
  });
};

const getBrandOrSupplierName = computed(() => {
  if (state.item.brand) {
    return state.item.brand.name;
  }

  return userStore.user?.clinic.name;
})

const getDescription = computed(() => {
  return state.item.description ?? '';
});

const checkTextOverflow = () => {
  if (descriptionContainer.value) {
    const element = descriptionContainer.value;
    isTextOverflowing.value = element.scrollHeight > element.clientHeight + 1;
  }
};

watch(() => state.item?.description, () => {
  nextTick(() => {
    checkTextOverflow();
  });
});

onMounted(() => {
  nextTick(() => {
    checkTextOverflow();
  })
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (state.item)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "px-0 pt-0 position-relative",
        style: {"background-color":"#F0F0F0","margin-bottom":"70px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "card-container" }, {
            default: _withCtx(() => [
              (!state.item.images || state.item.images.length == 0)
                ? (_openBlock(), _createBlock(_component_v_sheet, {
                    key: 0,
                    color: "#EEE",
                    height: "300",
                    width: "100%"
                  }))
                : (_openBlock(), _createBlock(_component_v_img, {
                    key: 1,
                    src: state.item.images[0].full,
                    height: "300",
                    width: "100%"
                  }, null, 8, ["src"])),
              _createVNode(_component_v_card_title, { class: "font-size-16-600" }, {
                default: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(state.item.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, { class: "font-size-12-400" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "pt-2 pb-0",
                        cols: "4"
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("p", { class: "font-grey-dark" }, "Brand:", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        class: "pt-2 pb-0",
                        cols: "6"
                      }, {
                        default: _withCtx(() => [
                          (getBrandOrSupplierName.value)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: _normalizeClass([{'secondary-background-button-color text-white': !state.item?.brand }, "brand font-black"])
                              }, _toDisplayString(getBrandOrSupplierName.value), 3))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "pt-2 pb-0",
                        cols: "4"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("p", { class: "font-grey-dark" }, "Product ID:", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        class: "pt-2 pb-0",
                        cols: "6"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(state.item.sku), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { class: "align-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        class: "pt-2 pb-0",
                        cols: "4"
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createElementVNode("p", { class: "font-grey-dark" }, "Price:", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        class: "pt-2 pb-0",
                        cols: "6"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_1, _toDisplayString(state.item.price_display), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (getDescription.value || state.item.attributes)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                class: "card-container mt-4 font-size-12-400"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    ref_key: "descriptionContainer",
                    ref: descriptionContainer,
                    class: _normalizeClass({'three-line-ellipsis': !showMore.value})
                  }, [
                    (getDescription.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "font-grey-dark" }, "Description", -1)),
                          _createElementVNode("p", _hoisted_3, _toDisplayString(getDescription.value), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (state.item.attributes)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.item.attributes, (attribute, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `attributes-${index}`,
                              class: "mt-4"
                            }, [
                              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(firstLetterUppercase)(attribute.name)), 1),
                              _createElementVNode("p", _hoisted_6, _toDisplayString(attribute.value), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  (isTextOverflowing.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_v_btn, {
                          ripple: false,
                          class: "primary-underline-button text-capitalize font-size-12-600 pa-0",
                          variant: "plain",
                          onClick: toggleText
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(showMore.value ? 'Show Less' : 'Show More'), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card, { class: "button-fix d-flex ga-3 align-center justify-space-between" }, {
            default: _withCtx(() => [
              _createVNode(ButtonBase, {
                "custom-class": "text-white primary-button",
                text: "Add to cart",
                onClick: addProduct
              }),
              _createVNode(QuantityEditor, {
                modelValue: state.qty,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.qty) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})